import { render, staticRenderFns } from "./addTier.vue?vue&type=template&id=6a4ce46a"
import script from "./addTier.vue?vue&type=script&lang=js"
export * from "./addTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports